import FlagIcon from "@mui/icons-material/Flag";
import useExcelUrl from "app/useExcelUrl";
import {
  DataGridV2 as DataGrid,
  DataGridBaseBaseProps,
  DataGridModalEditColumn,
  GridColumns,
  PageHeader,
} from "common";
import useAccess from "features/profile/useAccess";
import I18n from "i18n";
import { RedflagPartnerItem } from "./redflagPartnerApi";
import RedflagPartnerForm from "./RedflagPartnerForm";
import useRedflagPartnerList from "./useRedflagPartnerList";

export interface RedflagPartnerListProps extends Omit<
  DataGridBaseBaseProps,
  "id"
> {
  showHeader?: boolean;
}

export default function RedflagPartnerList({
  showHeader = true,
  ...props
}: RedflagPartnerListProps) {
  const { params, scope, editUrl, ...service } = useRedflagPartnerList();
  const { hasPermissions, canEditItem } = useAccess();
  const excelUrl = useExcelUrl("redflag-partners");
  let columns: GridColumns<RedflagPartnerItem> = [
    {
      field: "name",
      headerName: I18n.t("RedflagPartner.attributes.name"),
      renderCell: params => (
        <DataGridModalEditColumn
          href={`${editUrl}${params.row?.id}`}
          params={params}
        />
      ),
      flex: 1,
    },
    {
      field: "reason",
      headerName: I18n.t("RedflagPartner.attributes.reason"),
      flex: 2,
    },
  ];

  return (
    <>
      {showHeader && (
        <PageHeader
          avatar={<FlagIcon color="error" />}
          title={I18n.t("RedflagPartner.title")}
        />
      )}
      <DataGrid
        {...service}
        columns={columns}
        id="redflag-partners"
        excelUrl={excelUrl}
        renderModalForm={props => <RedflagPartnerForm {...props} />}
        modalProps={{ maxWidth: "lg" }}
        {...props}
        canCreate={hasPermissions("redflag_partner.create")}
        canDelete={hasPermissions([
          "redflag_partner.editany",
          "redflag_partner.editown",
        ])}
        canEdit={hasPermissions([
          "redflag_partner.editany",
          "redflag_partner.editown",
        ])}
        canDeleteRow={params => canEditItem("redflag_partner", params.row)}
        canEditRow={params => canEditItem("redflag_partner", params.row)}
        canBatchActions={hasPermissions([
          "redflag_partner.editany",
          "redflag_partner.editown",
        ])}
        canHandleTrash={hasPermissions([
          "redflag_partner.editany",
          "redflag_partner.editown",
        ])}
      />
    </>
  );
}
